import { SliceZoneC } from "@commercekit/prismic";
import { wrapIframe } from "@commercekit/shared";
import { asText } from "@prismicio/helpers";
import { useLoaderData } from "@remix-run/react";
import { useMemo } from "react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import { FaqSection } from "~/lib/prismic";

import { loader } from "~/routes-server/faq.server";

export { default as ErrorBoundary } from "~/components/atoms/GeneralErrorBoundary";

export { metaHelper as meta } from "~/lib/meta";
export type { headers } from "@commercekit/remix/lib.server";
export { loader };

const FaqPage = () => {
  const { content, faqSlice, faqSchema } = useLoaderData<typeof loader>();
  const { $pt } = usePrismicLabels();

  const description = useMemo(() => {
    return wrapIframe(asText(content.data.description));
  }, [content.data.description]);
  return (
    <>
    <section className="subpage">
      <div className="container">
        <div className="breadcrumbs py-3 mb-3">
          <a
            href="https://www.wovar.nl/"
            className="page first"
            data-icon-before=""
          >
            <i className="mobile d-lg-none" data-icon-before="">
              {$pt("breadcrumbs_label_home")}
            </i>
            <span className="show"> {$pt("breadcrumbs_label_home")}</span>
          </a>
          <i data-icon-after=""></i>
        </div>
        <div className="row">
          <article className="content mb-3 mb-lg-5">
            <h1 className="heading strong lg underlined left pb-3 pb-lg-2 mb-3 px-15px">
              {asText(content.data.title)}
            </h1>
            <div
              className="px-15px"
              dangerouslySetInnerHTML={{
                __html: description || "",
              }}
            ></div>
            <section className="text-content">
              <div className="d-sm-flex flex-wrap">
                {faqSlice?.length ? (
                  <SliceZoneC
                    slices={faqSlice}
                    components={{ faq_slice: FaqSection }}
                    defaultComponent={({ slice }) => (
                      <div>{slice.slice_type}</div>
                    )}
                  />
                ) : null}
              </div>
            </section>
          </article>
        </div>
      </div>
    </section>
    {faqSchema &&
      <script
        type="application/ld+json"
        data-schema-id="faq-schema"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    }
    </>
  );
};
export default FaqPage;
